/* ============================================================
   content.js — single source of truth for copy and product data.

   Everything about Pulled and Saved below is taken from the shipped
   apps and their own sites, including their real brand tokens, so the
   studio page reads as the parent of both rather than a stranger.
   ============================================================ */

/** Change this one line to route enquiries somewhere else. */
export const CONTACT_EMAIL = "support@abstudio.app";

export const ACTS = [
  { id: "top", label: "Index", note: "Where you are" },
  { id: "method", label: "Method", note: "How we build" },
  { id: "work", label: "Work", note: "Two apps, live" },
  { id: "count", label: "Count", note: "Numbers so far" },
  { id: "contact", label: "Contact", note: "Start something" },
];

export const MANIFESTO =
  "We build apps for the part of life that does not respond to advice. " +
  "No streak of reading fixes a habit. No saved article makes you braver. " +
  "So every product we ship measures one thing — what you actually did today — " +
  "and refuses to reward anything else.";

export const PRINCIPLES = [
  {
    n: "01",
    title: "Action over information",
    body: "Progress is a log of things done, not modules completed. If a screen cannot be earned, it does not ship.",
  },
  {
    n: "02",
    title: "Private by construction",
    body: "The hardest things people track are the things they would never post. No feeds, no brokers, nothing sold. Ever.",
  },
  {
    n: "03",
    title: "One loop, broken",
    body: "Each app targets a single self-repeating loop and puts a wedge in it. Scope is a feature, not a limitation.",
  },
  {
    n: "04",
    title: "Built to be felt",
    body: "Motion, weight and restraint are not decoration. An interface that feels considered is one people come back to.",
  },
];

export const TICKER = [
  "iOS",
  "Swift",
  "Habit design",
  "Behavioural loops",
  "Privacy first",
  "Independent",
  "Product",
  "Motion",
  "London",
];

export const APPS = [
  {
    id: "pulled",
    index: "AB—01",
    name: "Pulled",
    status: "Live on the App Store",
    category: "Confidence · Social skills",
    tagline: "Learn to talk to girls. Build real confidence.",
    lede:
      "Approach anxiety does not respond to theory. Pulled runs structured stages of audio lessons, then makes you go and do the thing — and only counts the doing.",
    quote: "Your growth is measured by what you actually do, not just what you know.",
    features: [
      ["Structured stages", "Foundations through mastery, each built on the last."],
      ["Theory meets practice", "Audio lessons paired with a real exercise, every module."],
      ["Confidence points", "Complete real-world challenges, earn CP, level up."],
      ["Your roster", "Every approach logged — name, socials, how it actually went."],
    ],
    proof: ["2,000+ lives changed", "Free to start", "No credit card"],
    links: {
      site: "https://getpulled.app",
      store: "https://apps.apple.com/us/app/pulled-learn-to-talk-to-girls/id6756056583",
    },
    theme: {
      bg: "#0d0d0f",
      fg: "#fff9ec",
      accent: "#fbca57",
      accent2: "#eb5160",
      paper: "#fdf8f3",
    },
  },
  {
    id: "saved",
    index: "AB—02",
    name: "Saved",
    // No public App Store listing found at build time; getsaved.app is the
    // download route. Add `links.store` here the moment the listing is up.
    status: "Live on iOS",
    category: "Recovery · Money",
    tagline: "Quit gambling. Keep the money.",
    lede:
      "The loop only runs in the dark. Saved turns every day you do not bet into a number you can see growing, and gives the urge somewhere to go for the two minutes it lasts.",
    quote: "Every day without a bet becomes money you keep.",
    features: [
      ["The money comes back", "One tap a day. Watch the streak grow — and the balance with it."],
      ["The calm comes back", "One button. Two minutes of breathing. It passes — every time."],
      ["The people come back", "Invite one person you trust. It doubles your odds."],
      ["The future comes back", "Give the money somewhere better to go. A trip. A car. Freedom."],
    ],
    proof: ["Answers never leave your phone", "No ads", "Nothing sold"],
    links: {
      site: "https://getsaved.app",
      store: null,
    },
    theme: {
      bg: "#0b1833",
      fg: "#eaf3ff",
      accent: "#90d1fe",
      accent2: "#57d43f",
      paper: "#fbf7ee",
    },
  },
];

export const COUNTS = [
  { value: 2, suffix: "", label: "Apps live on iOS", note: "Pulled · Saved" },
  { value: 2000, suffix: "+", label: "Lives changed", note: "Reported by Pulled users" },
  { value: 100, suffix: "%", label: "On-device by default", note: "Nothing sold, ever" },
  { value: 1, suffix: "", label: "Loop per product", note: "Scope is the feature" },
];
